import { FormControl } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';

import { IReverseConfig } from 'src/app/models/reverseConfig';
import { ApiLotsService } from 'src/app/services/api/api-lots.service';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import {
  DialogEmailTypeEnum,
  IEmailTemplateCard,
  IEmailTemplateInfo
} from 'src/app/models/email';
import { ModalEmailComponent } from '../configuracoes-email/modal-email/modal-email.component';
import { EmailService } from 'src/app/services/api/email.service';
import { ICustomSelect, IBatchEmailConfig } from './../../../models/generic';
import { IParameter } from 'src/app/models/parameter';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { IStoreConfig } from 'src/app/models/storeConfig';
import { TemplateVariableService } from 'src/app/services/template-variable.service';

@Component({
  selector: 'app-card-configuracoes',
  templateUrl: './card-configuracoes.component.html',
  styleUrls: ['./card-configuracoes.component.scss']
})
export class CardConfiguracoesComponent implements OnInit {
  @Input() parameter!: IParameter;
  @Input() cardType!: DialogEmailTypeEnum;
  @Input() templateData!: IEmailTemplateInfo;
  @Input() storeConfig!: IStoreConfig;
  @Input() reverseConfig!: IReverseConfig;
  @Input() typeReverseConfig!: string;

  @Output() updateParameterEvent = new EventEmitter<IParameter>();
  @Output() deleteParameterEvent = new EventEmitter();

  @Output() updateEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();

  emailTrigger: FormControl<string> = new FormControl<string>('', {
    nonNullable: true
  });

  cardData: {
    label: string;
    flexSize: number;
    value?: string | number;
    isSelect?: boolean;
  }[] = [];

  emailOpts: ICustomSelect[] = [
    { id: 'Manual', name: 'Manual' },
    { id: 'Automatic', name: 'Automatico' }
  ];

  DialogEmailTypeEnum = DialogEmailTypeEnum;

  constructor(
    private _dialogService: ApiDialogService,
    private _dialog: MatDialog,
    private _emailService: EmailService,
    private _snackbarService: SnackbarService,
    private _lotsService: ApiLotsService,
    private _templateVariableService: TemplateVariableService
  ) {}

  ngOnInit(): void {
    this.buildCardFields();

    if (this.isFaturamento()) {
      this.setValueEmailTrigger();
    }
  }

  isRepasse(): boolean {
    return this.cardType === DialogEmailTypeEnum.Transfer;
  }

  isFaturamento(): boolean {
    return this.cardType === DialogEmailTypeEnum.Invoice;
  }

  isParametros(): boolean {
    return this.cardType === DialogEmailTypeEnum.Parameters;
  }

  buildCardFields(): void {
    switch (this.cardType) {
      case DialogEmailTypeEnum.Transfer:
        this.cardData = [
          {
            label: 'Canal',
            flexSize: 2,
            value: (this.templateData as IEmailTemplateInfo)?.EventName.split(
              '.'
            )[0]
          },
          {
            label: 'Assunto',
            flexSize: 4,
            // Só leitura: mostra o rótulo da variável em vez do Handlebars cru.
            value: this._templateVariableService.toPlainLabels(
              (this.templateData as IEmailTemplateInfo)?.Subject
            )
          },
          {
            label: 'Tipo',
            flexSize: 2,
            value: 'Repasse'
          }
        ];
        break;

      case DialogEmailTypeEnum.Invoice:
        this.cardData = [
          {
            label: 'Banco',
            flexSize: 2,
            value: (this.templateData as IEmailTemplateInfo)?.EventName.split(
              '.'
            )[0]
          },
          {
            label: 'Assunto',
            flexSize: 4,
            // Só leitura: mostra o rótulo da variável em vez do Handlebars cru.
            value: this._templateVariableService.toPlainLabels(
              (this.templateData as IEmailTemplateInfo)?.Subject
            )
          },
          {
            label: 'Tipo',
            flexSize: 2,
            value: 'Faturamento'
          },
          {
            label: 'Disparo',
            flexSize: 3,
            value: this.templateData.TriggerValue ?? '',
            isSelect: true
          }
        ];
        break;

      case DialogEmailTypeEnum.Parameters:
        this.cardData = [
          {
            label: 'Nome do Parâmetro',
            flexSize: 3,
            value: this.parameter?.Name
          },
          {
            label: 'Valor',
            flexSize: 3,
            value: this.parameter?.Value
          }
        ];
        break;

      case DialogEmailTypeEnum.StoreConfig:
        let datePipe = new DatePipe('pt-BR');

        this.cardData = [
          {
            label: 'Subsidiária',
            flexSize: 1,
            value: this.storeConfig.Subsidiary
          },
          {
            label: 'Banco',
            flexSize: 1,
            value: this.storeConfig?.Bank
          },
          {
            label: 'Loja',
            flexSize: 1,
            value: this.storeConfig?.Store
          },
          {
            label: 'Produto',
            flexSize: 1,
            value: this.storeConfig?.Product
          },
          {
            label: 'Comissão',
            flexSize: 1,
            value: this.storeConfig?.Commission
              ? this.storeConfig?.Commission
              : '-'
          },
          {
            label: 'Centro de Custo',
            flexSize: 1,
            value: this.storeConfig?.CostCenter
              ? this.storeConfig?.CostCenter
              : '-'
          },
          {
            label: 'Dt. Vig. Inicio',
            flexSize: 1,
            value:
              datePipe.transform(this.storeConfig?.StartDate, 'dd/MM/yyyy') ??
              '-'
          },
          {
            label: 'Dt. Vig. Final',
            flexSize: 1,
            value:
              datePipe.transform(this.storeConfig?.FinishDate, 'dd/MM/yyyy') ??
              '-'
          },
          {
            label: 'Tipo Beneficiário',
            flexSize: 1,
            value: this.storeConfig?.BeneficiaryType
          },
          {
            label: 'Tipo Venda',
            flexSize: 1,
            value: this.storeConfig?.SaleType
          }
        ];
        break;

      case DialogEmailTypeEnum.ReverseConfig:
        this.cardData = [
          {
            label: 'Status Contrato',
            flexSize: 1,
            value: this.reverseConfig?.BatchStatus
          },
          {
            label: 'Prazo para estorno',
            flexSize: 1,
            value: this.reverseConfig?.Days
          },
          {
            label: 'Tipo de Estorno',
            flexSize: 1,
            value: this.reverseConfig?.Partial ? 'Parcial' : 'Integral'
          },
          {
            label: 'Valor do Estorno',
            flexSize: 1,
            value: this.reverseConfig?.IsValue
              ? this.reverseConfig?.Amount.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                })
              : this.reverseConfig?.Amount + '%'
          }
        ];
        this.setCardValueByReverseType();
        break;
    }
  }

  setCardValueByReverseType(): void {
    switch (this.typeReverseConfig) {
      case 'default':
        this.cardData.unshift(
          {
            label: 'Banco',
            flexSize: 1,
            value: this.reverseConfig?.Bank
          },
          {
            label: 'Canal',
            flexSize: 1,
            value: this.reverseConfig?.Channel
          }
        );
        break;

      case 'document':
        this.cardData.unshift({
          label: 'CPF/CNPJ Beneficiário',
          flexSize: 1,
          value: this.reverseConfig?.Document
        });
        break;
    }
  }

  setValueEmailTrigger(): void {
    const value = this.templateData.AutomaticEmail ? 'Automatic' : 'Manual';

    this.emailTrigger.setValue(value);
  }

  openParameterDialog(): void {
    this._dialogService.openParameterDialog(this.parameter).then((response) => {
      this.updateParameterEvent.emit(response as IParameter);
    });
  }

  openEmailDialog(): void {
    const dialogRef = this._dialog.open(ModalEmailComponent, {
      disableClose: true,
      panelClass: 'email-dialog',
      data: { type: this.cardType, infos: this.templateData }
    });

    dialogRef.afterClosed().subscribe({
      next: () => {}
    });
  }

  handleDeleteParameter(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Excluir template',
        title: 'Tem certeza que deseja excluir esse template?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) this.deleteTemplate();
    });
  }

  deleteTemplate(): void {
    const id = (this.templateData as IEmailTemplateInfo)?.TemplateId ?? '';

    this._emailService.deleteTemplate(id).subscribe({
      next: (res) => {
        this.deleteParameterEvent.emit();
        this._snackbarService.openSnackBar(
          'Template excluído com sucesso!',
          'success'
        );
      }
    });
  }

  changeEmailSelect(): void {
    const emailConfig: IBatchEmailConfig = {
      BankId: this.templateData.BankId ?? '',
      Name: this.templateData.Name ?? '',
      AutomaticEmail: this.emailTrigger.value === 'Automatic'
    };

    this._lotsService.saveBatchEmailConfig(emailConfig).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar(
          'Disparo de e-mail atualizado com sucesso!',
          'success'
        );
      }
    });
  }

  handleDialogConfig(type: 'edit' | 'delete'): void {
    switch (type) {
      case 'edit':
        this.updateEvent.emit();
        break;

      case 'delete':
        this.deleteEvent.emit();
    }
  }
}
